export default __webpack_public_path__ + "static/media/hold.a99ee500.svg";